var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInComingHwClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "202px",
    viewBox: "0 0 76 202",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u9AD8\u538B\u8FDB\u7EBF\u56DE\u8DEF-\u95ED\u5408") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3076-\\u4E00\\u6B21\\u8FDB\\u7EBF\\u56FE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-699.000000, -760.000000)",
    id: "\\u9AD8\\u538B\\u8FDB\\u7EBF\\u56DE\\u8DEF-\\u95ED\\u5408"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(699.500000, 761.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u53D8\\u538B\\u56DE\\u8DEF\\u5907\\u4EFD",
    transform: "translate(24.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-42",
    stroke: "#E64242",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27\\u5907\\u4EFD-3",
    transform: "translate(0.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 0.5,
    x2: 6.5,
    y2: 10.5,
    id: "\\u76F4\\u7EBF-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 11.5,
    x2: 12.5,
    y2: 11.5,
    id: "\\u76F4\\u7EBF-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 14.5,
    x2: 10.5,
    y2: 14.5,
    id: "\\u76F4\\u7EBF-6\\u5907\\u4EFD"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 17.5,
    x2: 8.5,
    y2: 17.5,
    id: "\\u76F4\\u7EBF-6\\u5907\\u4EFD-2"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 46.5,
    y1: -5.32560107e-14,
    x2: 46.5,
    y2: 50,
    id: "\\u76F4\\u7EBF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.5,
    y1: 50,
    x2: 46.5,
    y2: 66,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.5,
    y1: 89,
    x2: 46.5,
    y2: 200,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u76F4\\u7EBF-7",
    transform: "translate(26.500000, 63.000000) scale(-1, 1) translate(-26.500000, -63.000000) ",
    points: "6.5 50 46.5 50 46.5 76"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-2",
    fill: "#FF4D4F",
    x: 42,
    y: 65.5,
    width: 9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-15",
    transform: "translate(0.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-33",
    transform: "translate(22.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-10",
    transform: "translate(24.000000, 6.500000) scale(-1, 1) translate(-24.000000, -6.500000) translate(17.000000, 4.500000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 2,
    x2: 7,
    y2: 2,
    id: "\\u76F4\\u7EBF-3",
    stroke: "#52C41A",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u76F4\\u7EBF-3\\u5907\\u4EFD",
    fill: "#52C41A",
    points: "7 -2.85882429e-15 14 2 7 4"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    stroke: "#52C41A",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 30,
    height: 11
  })), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 6.5,
    x2: 32,
    y2: 6.5,
    id: "\\u76F4\\u7EBF-8\\u5907\\u4EFD-4",
    stroke: "#52C41A",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-39",
    transform: "translate(11.250000, 31.500000) scale(-1, 1) translate(-11.250000, -31.500000) translate(0.000000, 6.500000)",
    stroke: "#52C41A",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84-8",
    points: "0 0 16 0 16 32"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27\\u5907\\u4EFD-2",
    transform: "translate(9.500000, 32.000000)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 0.5,
    x2: 6.5,
    y2: 10.5,
    id: "\\u76F4\\u7EBF-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 11.5,
    x2: 12.5,
    y2: 11.5,
    id: "\\u76F4\\u7EBF-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 14.5,
    x2: 10.5,
    y2: 14.5,
    id: "\\u76F4\\u7EBF-6\\u5907\\u4EFD"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 17.5,
    x2: 8.5,
    y2: 17.5,
    id: "\\u76F4\\u7EBF-6\\u5907\\u4EFD-2"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInComingHwClose);
export default __webpack_public_path__ + "static/media/inComing_hw_close.0bc15ff57c51e36213116fbe7a08819c.svg";
export { ForwardRef as ReactComponent };